export default __webpack_public_path__ + "static/media/openwrt.c1608808.png";